module.exports = __webpack_public_path__ + "img/NI.63f4de3e.png";